import styled from 'styled-components';
import { GlobalToken } from 'antd';

export const ScrollbarContainer = styled.div`
  position: relative;
  height: 80%;
  width: 100%;
  display: flex;
`;

export const ContentWrapper = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: auto;
  flex: 1;
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none; /* Chrome/Safari */
  }
`;

export const ScrollbarTrack = styled.div<{ theme: { token: GlobalToken } }>`
  position: relative;
  width: 8px;
  background: ${({ theme: { token } }) => token.colorBgLayout};
  border-radius: 4px;
  margin-left: 4px;
  cursor: pointer;
`;

export const ScrollbarThumb = styled.div<{ $height: number; theme: { token: GlobalToken } }>`
  position: absolute;
  width: 100%;
  height: ${props => props.$height}px;
  background: ${({ theme: { token } }) => token.colorBorder};
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s;
  min-height: 30px;

  &:hover {
    background: ${({ theme: { token } }) => token.colorIconHover};
  }
`;
